export default __webpack_public_path__ + "static/media/tss_white.54e1c81b.png";